import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { isValidElement } from 'react';
import { Loader } from '@hh.ru/magritte-ui-loader';
import { TextDynamic, Text } from '@hh.ru/magritte-ui-typography';

var styles = {"container":"magritte-container___mF4Tb_4-1-9","text":"magritte-text___hzlS4_4-1-9"};

const TextDefaultStyleMap = {
    title: 'primary',
    subtitle: 'secondary',
    description: 'tertiary',
};
const CellText = ({ showLoader = false, style, type = 'title', 'data-qa': dataQa = 'cell-text', maxLines, children, icon, }) => {
    const typography = type === 'title' ? 'label-2-regular' : 'label-3-regular';
    const textStyle = style || TextDefaultStyleMap[type];
    if (!children) {
        return null;
    }
    return (jsxs("div", { className: styles.container, "data-qa": dataQa, children: [showLoader && !isValidElement(icon) && jsx(Loader, {}), isValidElement(icon) && icon, jsx(TextDynamic, { children: jsx("div", { className: styles.text, style: { WebkitLineClamp: maxLines || 'none' }, children: jsx(Text, { typography: typography, style: textStyle, children: children }) }) })] }));
};

export { CellText };
//# sourceMappingURL=CellText.js.map
